import React, {Component} from 'react'
import serverRepo from '../requests/servers'
import Loading from '../components/Loading'
import utils from '../utils/utils'
import _ from 'lodash'
import ZoneItem from './server/ZoneItem'
// import Collapse from 'rc-collapse'
// import { Collapse, Button, CardBody, Card } from 'reactstrap';

// const Panel = Collapse.Panel
// require('rc-collapse/assets/index.css');

export default class Worker extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      rows: [],
      loading: false,
      byZone: {}
    }
    setInterval(() => {
      this.loadServers()
    }, Number(30 * 1000))
  }
  componentWillMount () {
    this.setState({loading:true})
    this.loadServers()
  }
  async loadServers(){
    let data = await serverRepo.getServers()
    const servers = ((data && _.isArrayLike(data.servers))) ? data.servers : []
    let byZone = (servers && _.isArrayLike(servers)) ? _.groupBy(servers, 'zone') : []
    console.log(data)
    console.log('byzone', byZone)
    this.setState({loading:false, rows: servers, byZone: byZone})
  }

  render(){
    if (this.state.loading) {
      return (<Loading/>)
    }
    // let deltaTime = Number(10  * 60 * 1000)
    // const rows = this.state.rows.map((item) => {
    //   let onlineTime = new Date().getTime() - deltaTime
    //   let styleOnlie = (item.notified >= onlineTime) ? 'circle-arrow-up online' : 'circle-arrow-down offline'
    //   return (
    //   <tr key = {item.ip}>
    //     <td>{utils.getOnlineStyle(item.notified)}</td>
    //     <td>{item.ip}</td>
    //     <td>{item.zone}</td>
    //     <td>{item.server_type}</td>
    //     <td className={utils.getLoadStyles(item.avg_load)}>{item.avg_load}%</td>
    //     <td className={utils.getLoadStyles(item.network)}>{item.network}%</td>
    //     <td className={utils.getLoadStyles(item.storage)}>{item.storage}%</td>
    //   </tr> )
    // })
    const rowByzone =  []
    for (const zone in this.state.byZone) {
      let servers = _.get(this.state.byZone, zone)
      console.log(servers)
      rowByzone.push(
       <ZoneItem key={zone} zone={zone} servers={servers}/>
      )
    }
    // const items = this.state.rows.map((item) => {
    //   let onlineTime = new Date().getTime() - deltaTime
    //   let styleOnlie = (item.notified >= onlineTime) ? 'circle-arrow-up online' : 'circle-arrow-down offline'
    //   return (
    //     <Panel header={`${item.server_host}(${item.ip})`}>
    //         <div>this is panel content</div>
    //     </Panel>
    //   )
    // })
    return(
      <div>
        <h1 className='loading'>Cloud - Servers ({this.state.rows.length})</h1>
        {/* <Collapse accordion={false} className="text-black">
          {items}
        </Collapse> */}
        {rowByzone}
          {/* <div>
            <table className='table table-hover table-bordered table-ms'>
              <thead>
                <tr className='active'>
                  <th>Status</th>
                  <th>Ip</th>
                  <th>Zone</th>
                  <th>Type</th>
                  <th>Avg Load</th>
                  <th>Network</th>
                  <th>Storage</th>
                </tr>
              </thead>
              <tbody>
                {rows}
              </tbody>
            </table>
          </div> */}
    </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Servers.js